import React,{ useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { formatCurrency } from '../services/formatservice';


export const AvgPrice = (props) => {
  const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  function info() {
    return(
      <div>
        <h2>Snittpris: {formatCurrency(data.statistics.avgprice)}</h2>
      </div>
    )
  }

  let content = loaded
    ? info()
    : <Spinner/>;

    return(
      <>
        {content}
      </>
    );
}